
// Module
import routes from './routes';

export default angular.module( 'app.createAccount.module',
    [] )
    .config(routes)
    .name;



/** WEBPACK FOOTER **
 ** ./src/guest/createAccount/index.js
 **/